import { Image } from '@codeparva/ui-components-library';
import React from 'react';
import { HeroTypes } from '..';
import { CPImage } from '../../../../../components/imageWrapper/CPImage';
import { weakKey } from '../../../../../utilities/weakKey';
import Carousel, {
  CarouselItem,
} from '../../../../homePage/components/jumbotron/components/carousel/Carousel';

export const Gallery = ({ photos }: HeroTypes.IGallery) => {
  const GetRightImageComponent = (
    data: HeroTypes.TLocationPhoto,
    className = ''
  ) => {
    if (data && data.gatsbyImageData) {
      return (
        <CPImage
          gatsbyImageData={data.gatsbyImageData}
          className={className}
          style={{
            width: '100%',
            height: '100%',
          }}
        />
      );
    }
    return <Image src={data.url} fullwidth className={className} />;
  };

  if (photos && photos.length === 1) {
    const photo = photos[0];
    return (
      <div className="galleryContainer">{GetRightImageComponent(photo)}</div>
    );
  }
  return (
    <Carousel>
      {photos &&
        photos.map(imagesSrc => (
          <CarouselItem width="100%" key={weakKey(imagesSrc)}>
            <div className="galleryContainer">
              {GetRightImageComponent(imagesSrc)}
            </div>
          </CarouselItem>
        ))}
    </Carousel>
  );
};
